export const PRIVACY_POLICY_URL = 'https://mybundle.app/privacy-policy/';
export const TOS_URL = 'https://mybundle.app/terms-of-use/';
